<!------------------------------------------------------------------------------
 File: EventTicketSales 
 Created by keni.
 with: IntelliJ IDEA
 Date: 10/07/2018
 Time: 13:53
------------------------------------------------------------------------------->
<template>
    <div class="table-responsive">
        <div class="d-table table">
            <div class="tbody tr watch-transition cursor-pointer"
                    :class=""
                    :key="index"
                    v-on:click="requestSale(sale)"
                    v-for="sale,index in ticket_sales"
            >
                <template v-if="isRefunded(sale)">
                    <div class="td"><del>{{setDate(sale.created_at)}}</del></div>
                    <div class="td"><del>{{sale.sale.user.first_name}}</del></div>
                    <div class="td"><del>{{sale.sale.user.last_name}}</del></div>
                    <div class="td"><del>{{sale.sale.user.email}}</del></div>
                    <div class="td">
                    <span
                            class="font-weight-bold"
                    >
                        <del>{{currency}}{{money(sale.price_paid)}}</del></span>
                    </div>
                </template>
                <template v-else>
                    <div class="td ">{{setDate(sale.created_at)}}</div>
                    <div class="td">{{sale.sale.user.first_name}}</div>
                    <div class="td">{{sale.sale.user.last_name}}</div>
                    <div class="td">{{sale.sale.user.email}}</div>
                    <div class="td">
                    <span
                            class="font-weight-bold"
                    >
                        {{currency}}{{money(sale.price_paid)}}</span>
                    </div>
                </template>
            </div>
            <!--<transition-group-->
            <!--name="slideLeft"-->
            <!--tag="div"-->
            <!--class="tbody">-->

            <!--</transition-group>-->

        </div>
    </div>
</template>

<script>
	import {format as formatMoney} from '../../../../../app/Shared/Resources/Assets/js/helpers/money';
	import {createUrlFromUrlAndParams} from '../../../../../app/Shared/Resources/Assets/js/helpers/routes';
import {DATE_FORMAT,getDate} from '../../../../../app/Shared/Resources/Assets/js/helpers/format.date';

	export default {
		name: "event_ticket_sales",
		components: {},
		props: {
			ticket_sales: {},
			currency: String,
			sale_route_name: String,
			sale_route_uri: String,

		},
		created() {
		},
		destroyed() {
		},
		mounted() {

		},
		data() {
			return {
				viewing: false,
				sale_route: ''
			}
		},
		methods: {
			setDate(date){
				return getDate(date,DATE_FORMAT.date_time.short);
            },
			/**
             * Check if the current record has been refunded
			 * @param sale
			 * @returns {boolean}
			 */
			isRefunded(sale){
				if(sale.status == 'cancelled'){
					return true
                }
				if(sale.sale.total_amount_refunded >= sale.sale.total_price_paid){
					return true
				}
            },
			requestSale(sale) {
				// console.log('requestSale', 'sale',sale.sale.user);
				if (!('no_link' in sale.sale.user)) {
					window.location.href = createUrlFromUrlAndParams(this.sale_route_uri, sale.sale_id);
				}
				return false;

			},
			log(...args) {
				console.log(...args);
			},
			money(price, params) {
				return formatMoney(price, params)
			},
		},
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/modules/EventTicketSales.vue?488a2ad7